module.exports = __webpack_public_path__ + "img/today.92fe02bb.png";